module.exports = __webpack_public_path__ + "images/gap-icon.44a1b1267f593a5578f84adbe0305699.png";